import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
    withCredentials: true,
    baseURL: API_URL,
});

api.interceptors.request.use((config) => {
    config.headers.Authorization = `Ts ${localStorage.getItem('token')}`;
    return config;
});

api.interceptors.response.use(
    (config) => {
        return config;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error?.response?.status === 401 && error.config && !error.config._isRetry) {
            originalRequest._isRetry = true;
            try {
                const response = await axios.get(`${API_URL}/auth/refresh`, {
                    withCredentials: true,
                });
                localStorage.setItem('token', response.data.aT);
                return api.request(originalRequest);
            } catch (e) {
                console.log('Не пользователь...');
            }
        }
        throw error;
    }
);

export default api;
